import { EventContext, EventDefinitionContext, FormDefinitionContext, InstitutionContext, PatientContext, useFormMetadata, useFormValidateWithIds } from "@ngt/opms";
import { useContext } from "react";

const useValidate = () => {
    
    const { data: institution } = useContext(InstitutionContext)
    const { data: patient } = useContext(PatientContext)
    const { data: event } = useContext(EventContext)
    const { data: eventDefinition } = useContext(EventDefinitionContext)
    const { data: formDefinition } = useContext(FormDefinitionContext)
    const formMetadata = useFormMetadata(formDefinition?.id);
    
    const validate = useFormValidateWithIds(formMetadata, institution?.id, patient?.id, eventDefinition?.id, event?.repeat, 500);

    return validate;
}

export default useValidate;